import React, { ChangeEvent } from "react";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

import useStyles from "./styles";

interface IProps<T extends string | number> {
  activeTab: T;
  enumValues: Record<string, T>;
  onTabChange: (tab: T) => void;
  tabLabels?: Partial<Record<T, string>>;
  totalNumber?: number;
}

const DashboardCardTabs = <T extends string | number>(props: IProps<T>) => {
  const { activeTab, enumValues, onTabChange, tabLabels, totalNumber } = props;

  const classes = useStyles();

  const handleChangeActiveTab = (
    event: ChangeEvent<HTMLButtonElement>,
    value: T
  ) => {
    onTabChange(value);
  };

  const tabs: T[] = React.useMemo(
    () => Object.values(enumValues),
    [enumValues]
  );

  const tabsContent = tabs.map(tab => {
    const label = tabLabels?.[tab] ?? String(tab);
    const tabLabel = (
      <span>
        {typeof totalNumber === "number" && activeTab === tab
          ? `${label} (${totalNumber})`
          : label}
      </span>
    );

    return (
      <Tab
        key={tab as React.Key}
        className={classes.tab}
        label={tabLabel}
        value={tab}
      />
    );
  });

  return (
    <>
      <Tabs
        variant={"fullWidth"}
        value={activeTab}
        className={classes.tabs}
        onChange={handleChangeActiveTab}
        TabIndicatorProps={{
          className: classes.activeTab
        }}
      >
        {tabsContent}
      </Tabs>
    </>
  );
};

export default React.memo(DashboardCardTabs);
